import { createPopper } from '@popperjs/core';
import Bootstrap from 'bootstrap';

import "%modules%/chat/chat";
